// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"project_wrapper__2Rn4v","text":"project_text__26cCn","content":"project_content__3Yfw7","overlay":"project_overlay__FDAct"};